import ContactPage from "../../components/contactPage/ContactPage.jsx";

const EvContactPage = (props) => (
  <ContactPage
    createAspRequest={props.createAspRequest}
    onRequestError={props.onRequestError}
    fetchAspTopProvidersByMatchScore={props.fetchAspTopProvidersByMatchScore}
    handleBack={props.handleBack}
    handleNext={props.handleNext}
    isFillingMethodAutoJump={props.isFillingMethodAutoContactJump}
    match_score_weights={props.match_score_weights}
    onFillingMethodAutoBackToFillingMethod={
      props.onFillingMethodAutoBackToFillingMethod
    }
  />
);

export default EvContactPage;
